module.exports = __webpack_public_path__ + "img/36239-008.f1f2bb52.jpg";